import { createAsyncThunk } from '@reduxjs/toolkit';
import { TFetchFormParams, TFormResponse } from 'shared/types/form';
import { IThunkApi } from 'shared/types/redux';
import { fetchForm } from 'shared/services/fetchForm';
import { ResponseError } from 'shared/errors';
import { addNotification, setStep } from 'shared/slices';

export const sendForm = createAsyncThunk<TFormResponse, TFetchFormParams, IThunkApi>(
  'form/sendForm',
  async (params, thunkApi) => {
    const { rejectWithValue, extra, dispatch } = thunkApi;

    try {
      const { response, statusCode } = await fetchForm(extra, params);

      if (statusCode === 200) {
        dispatch(setStep(2));

        return response;
      }

      throw new ResponseError({
        domain: 'sendForm',
        message: response.message,
      });
    } catch (e) {
      extra.logger.error(e);

      dispatch(addNotification({ text: 'Что-то пошло не так — попробуйте ещё раз', type: 'error' }));

      return rejectWithValue(e.message);
    }
  },
);
